const {
  SELECT_EMPLOYEE,
  UNSELECT_EMPLOYEE,
  RESET_STATE,
} = require("redux/constants/EmployeeSelectionConstants");

const INITIAL_STATE = {
  selectedEmployee: [],
};

const employeeSelectedReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SELECT_EMPLOYEE:
      return {
        ...state,
        selectedEmployee: [...state.selectedEmployee, action.payload],
      };
    case UNSELECT_EMPLOYEE:
      return {
        ...state,
        selectedEmployee: state.selectedEmployee.filter(
          (key) => key !== action.payload
        ),
      };
    case RESET_STATE:
      return action.payload;
    default:
      return state;
  }
};

export default employeeSelectedReducer;
